"use client";
import React from "react";

export default function FeaturesNumbered({ data }) {
  const { title, subtitle, features = [], background = {} } = data || {};

  const bgStyle =
    background.type === "color"
      ? { backgroundColor: background.value }
      : background.type === "gradient"
        ? { backgroundImage: background.value }
        : {};

  return (
    <section className="py-20 px-4" style={bgStyle}>
      <div className="max-w-6xl mx-auto text-center">
        {title && (
          <h2 className="text-3xl font-bold mb-2 text-foreground">{title}</h2>
        )}
        {subtitle && <p className="text-muted-foreground mb-10">{subtitle}</p>}

        <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-3">
          {features.map((item, idx) => (
            <div key={idx} className="text-left">
              <div className="text-4xl font-bold text-primary mb-2">
                #{idx + 1}
              </div>
              <h3 className="text-xl font-semibold text-foreground">
                {item.title}
              </h3>
              <p className="text-muted-foreground mt-1">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
